import styled from 'styled-components';
import { Form } from 'formik';
import { fontTitle, fontBody } from 'Styles/fonts';
import { red, grey80, bombasBlue } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import ButtonOriginal from '../../../Button/Button';
import TextInputOriginal from '../../../TextInput/TextInput';
import ContentfulTextBlockOriginal from '../../../ContentfulTextBlock/ContentfulTextBlock';
import { Error } from '../../../FormInput/FormInput.styled';

export const CouponDialogSmsForm = styled.div``;

export const ContentContainer = styled.div`
  text-align: center;
  margin: 0 auto;

  ${breakpoint('medium')} {
    width: 496px;
  }
`;

export const BodyHeading = styled.p`
  ${fontTitle(18)}
  margin-bottom: 4px;
`;

export const SmsForm = styled(Form)`
  ${breakpoint('medium')} {
    display: flex;
  }
`;

export const TextInput = styled(TextInputOriginal)`
  ${Error} {
    text-align: start;
    color: ${red};
  }

  ${breakpoint('medium')} {
    margin: 0 6px 0 0;
    width: 288px;
  }
`;

export const Button = styled(ButtonOriginal)`
  height: 40px;
  width: 100%;
  margin-top: 8px;

  ${breakpoint('medium')} {
    display: flex;
    height: 48px;
    width: unset;
    margin: 0;
  }
`;

export const ContentfulTextBlock = styled(ContentfulTextBlockOriginal)`
  display: block;
  position: relative;
  margin: 0 auto 16px;

  p {
    ${fontBody(12)};
    color: ${grey80};
  }

  ${breakpoint('medium')} {
    max-width: 624px;
  }

  a {
    color: ${bombasBlue};
    text-decoration: underline;
  }
`;
